// extracted by mini-css-extract-plugin
export default {"portfolio__user__management__panel":"PortfoliosUsersManagement_portfolio__user__management__panel__IXVT8"};